export default class StoresActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_STORE='GET_HELPER_STORE';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  

  static submit(){
    return {
      type: StoresActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: StoresActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: StoresActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: StoresActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: StoresActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: StoresActions.SHOW_DATA,
      payload: data
    };
  }
  static error(error){
    return {
      type: StoresActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: StoresActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: StoresActions.PROCESS_DATA,
    };
  }
  static resetList(){
    return {
      type: StoresActions.RESET_LIST,
    };
  }
  static reset(){
    return {
      type: StoresActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: StoresActions.GET_HELPER_STORE,
      payload:data
    };
  }

  static errorInternal(error){
    return {
      type: StoresActions.ERROR_SERVER,
      payload: error
    };
  }
}